import React from 'react';
import { Paper, Typography, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Line } from 'react-chartjs-2';

// colores predefinidos removidos (no usados)

function agruparPorHora(lecturas, campo) {
  const horas = Array(24).fill(null).map(() => []);
  lecturas.forEach(l => {
    if (!l.fecha) return;
    const hora = new Date(l.fecha).getHours();
    if (l[campo] !== undefined && l[campo] !== null) {
      horas[hora].push(Number(l[campo]));
    }
  });
  return horas.map(arr => arr.length ? arr.reduce((a, b) => a + b, 0) / arr.length : 0);
}

const GraficaPorHora = ({ lecturas, campo, titulo, color, unidad }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const promedios = agruparPorHora(lecturas, campo);
  const data = {
    labels: Array.from({ length: 24 }, (_, i) => `${i}:00`),
    datasets: [
      {
        label: titulo,
        data: promedios,
        borderColor: color,
        backgroundColor: color.replace('1)', '0.2)'),
        borderWidth: 1,
        tension: 0.7,
        pointRadius: 3,
      },
    ],
  };
  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      title: { display: true, text: titulo },
    },
    maintainAspectRatio: false,
    scales: {
      x: {
        title: { display: true, text: 'Hora del día' },
        ticks: { font: { size: 10 } },
        grid: { lineWidth: 0.5 },
        offset: false,
      },
      y: { title: { display: true, text: unidad || campo }, min: 0 },
    },
  };
  return (
    <Paper sx={{ p: 3, mt: 2, maxWidth: isMobile ? '100%' : 900, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        {titulo}
      </Typography>
      <Box sx={{ height: isMobile ? 420 : 350, overflowX: 'auto', width: '100%' }}>
        <Line data={data} options={options} />
      </Box>
    </Paper>
  );
};

export default GraficaPorHora;
